<template>
	<div>List</div>
</template>

<script>

export default {
	components: {
	},
	computed: {
	},
	data() {
		return {
		};
	},
};
</script>
